/*
 * @Descripttion:
 * @version:
 * @Author: JiaLe
 * @Date: 2021-09-18 10:26:59
 * @LastEditors: your name
 * @LastEditTime: 2025-02-19 15:27:19
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { registerApp } from "./register";
import { Locale } from "vant";
import Vant from "vant";
import "vant/lib/index.css";
// import MintUI from "mint-ui";
import enUS from "vant/es/locale/lang/en-US";
// import zhCN from "vant/es/locale/lang/zh-CN";

import "../src/assets/style/reset.css";
import axios from "axios";
// import dayjs from "dayjs";
import "../src/assets/style/reset.css";
import { allUrl } from "./commonJs/baseUrl";
// import md5 from "js-md5";
import dayjs from "dayjs";
import VueI18n from 'vue-i18n'
import am from './lang/am'
import ar from './lang/ar'
import en from './lang/en'
import es from './lang/es'
import fil from './lang/fil'
import fr from './lang/fr'
import ja from './lang/ja'
import my from './lang/my'
import ne from './lang/ne'
import pt from './lang/pt'
import tr from './lang/tr'
import vi from './lang/vi'
import zh from './lang/zh'
import { stateCome, sToM, sToMs, isnum, isnull } from "@/commonJs/validate";
import {
  getRequest,
  getRequestNoToken,
  postRequest1,
  getRequest1,
  postDatajgold,
  postDataRequest,
  postDataRequestja,
  postDatajRequest,
  postDatajNoTokenRequest,
  formatDate,
  uploadFileRequest,
} from "./commonJs/request";

import { getIcon, getUserIcon, toThousands } from "@/commonJs/common";

// 获取签名方法
// import { getSign, getSign1, paramsStrSort } from "./commonJs/getSign";
Vue.filter("stateCome", stateCome);
Vue.filter("sToM", sToM);
Vue.filter("sToMs", sToMs);
Vue.filter("isnum", isnum);
Vue.filter("isnull", isnull);

// 注册全局组件
// vantlist(Vue)
Vue.use(Vant);
Vue.use(VueI18n)

Vue.prototype.$axios = axios;
Vue.prototype.allUrl = allUrl;
Vue.prototype.gets = getRequest;
Vue.prototype.gets2 = getRequestNoToken;
Vue.prototype.postData = postDataRequest;
Vue.prototype.postDatajav = postDataRequestja;
Vue.prototype.postDatajs = postRequest1;
Vue.prototype.getDatajs = getRequest1;

Vue.prototype.postDataj = postDatajRequest;
Vue.prototype.postDataj2 = postDatajNoTokenRequest;
Vue.prototype.formatDate = formatDate;
Vue.prototype.uploadFileRequest = uploadFileRequest;
Vue.prototype.postDatajgold = postDatajgold;

Vue.prototype.dayjs = dayjs; // 可以全局使用dayjs
Vue.prototype.getIcon = getIcon; // 可以全局使用dayjs
Vue.prototype.getUserIcon = getUserIcon; // 可以全局使用dayjs
Vue.prototype.toThousands = toThousands; // 可以全局使用dayjs

// Vue.prototype.$md5 = md5;
// Vue.prototype.$Toast = MintUI.Toast;
// Vue.prototype.$debounce = debounce;
// Vue.prototype.getSign = getSign;
// Vue.prototype.getSign1 = getSign1;

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || ""; // 获取当前路由的 meta 字段中的 title，并赋值给 document.title
  next();
});
// router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   if (isChunkLoadFailed) {
//     window.location.reload();
//   } else {
//     console.log(error);
//   }
// });

const q = window.location.hash.split("?")[1];
console.log("页面参数", q);
function getQueryVariable(variable) {
  const query = window.location.hash.split("?")[1];
  if (query) {
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split("=");
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  } else {
    return false;
  }
}
if (getQueryVariable("token")) {
  localStorage.setItem("token", getQueryVariable("token"));
}
if (getQueryVariable("uid")) {
  localStorage.setItem("uid", getQueryVariable("uid"));
}
if (getQueryVariable("aid")) {
  localStorage.setItem("aid", getQueryVariable("aid"));
}
if (getQueryVariable("isRoom")) {
  localStorage.setItem("isRoom", getQueryVariable("isRoom"));
}
if (getQueryVariable("safeTop")) {
  localStorage.setItem("safeTop", getQueryVariable("safeTop"));
}
if (getQueryVariable("deviceType")) {
  localStorage.setItem("deviceType", getQueryVariable("deviceType"));
}
if (getQueryVariable("version")) {
  localStorage.setItem("version", getQueryVariable("version"));
}
if (getQueryVariable("channel")) {
  localStorage.setItem("channel", getQueryVariable("channel"));
}
if (getQueryVariable("isAppUse")) {
  localStorage.setItem("isAppUse", getQueryVariable("isAppUse"));
}
if (getQueryVariable("roomId")) {
  localStorage.setItem("roomId", getQueryVariable("roomId"));
}
if (getQueryVariable("content")) {
  localStorage.setItem("content", getQueryVariable("content"));
} else {
  localStorage.setItem("content", 'no');

}
if (getQueryVariable("rankType")) {
  localStorage.setItem("rankType", getQueryVariable("rankType"));
}
if (getQueryVariable("channel_id")) {
  localStorage.setItem("channel_id", getQueryVariable("channel_id"));
}
if (getQueryVariable("source")) {
  localStorage.setItem("source", getQueryVariable("source"));
}
if (getQueryVariable("gameHallType")) {
  localStorage.setItem("gameHallType", getQueryVariable("gameHallType"));
}
if (getQueryVariable("momentld")) {
  localStorage.setItem("momentld", getQueryVariable("momentld"));
}
if (getQueryVariable("languageType")) {
  localStorage.setItem("languageType", getQueryVariable("languageType"));
}
Locale.use("en-US", enUS);
localStorage.setItem("locale", "en");

// if (getQueryVariable("languageType")) {
//   // en-US 英文 zh-CN 中文 in 印地语
//   let entry = "";
//   if (getQueryVariable("languageType") === "en") {
//     entry = "en";
//     // vant组件 切换英文
//     Locale.use("en-US", enUS);
//   }
//   if (getQueryVariable("languageType") === "zh") {
//     entry = "zh";
//     Locale.use("zh-CN", zhCN);
//   }
//   if (getQueryVariable("languageType") === "hi") {
//     entry = "hi";
//     // vant组件 切换印地语
//     // Locale.use("hi-IN", idID);
//   }
//   // localStorage.removeItem('locale')
//   localStorage.setItem("locale", entry);
// }



const i18n = new VueI18n({
  locale: getQueryVariable("languageType") ? getQueryVariable("languageType") : 'en', // 设置默认语言环境
  messages: { // 加载语言包
    // zh,
    am,
    ar,
    en,
    es,
    fil,
    fr,
    ja,
    my,
    ne,
    pt,
    tr,
    vi,
    zh,
  }
})

// 设置阿拉伯语RTL方向
const currentLocale = i18n.locale;
if (currentLocale === 'ar') {
  document.documentElement.setAttribute('dir', 'rtl');
} else {
  document.documentElement.setAttribute('dir', 'ltr');
}


Vue.config.productionTip = false;
registerApp(Vue);
// setupStore(); //动态路由持久化
const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
});
app.$mount("#app");


